import { render, staticRenderFns } from "./PartnerWithdrawalBatchApprovalModal.vue?vue&type=template&id=b4ac4644&scoped=true&"
import script from "./PartnerWithdrawalBatchApprovalModal.vue?vue&type=script&lang=js&"
export * from "./PartnerWithdrawalBatchApprovalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ac4644",
  null
  
)

export default component.exports